const Purchase = () => import('./pages/Purchase.vue');
const PurchaseRegister = () => import('./pages/PurchaseRegister.vue');
const PurchaseEdit = () => import('./pages/PurchaseEdit.vue');

export default [
  {
    path: '/inventory/purchase',
    name: 'Purchase',
    component: Purchase,
    meta: {
      title: 'Compras',
    },
  },
  {
    path: '/inventory/purchase/new',
    name: 'PurchaseRegister',
    component: PurchaseRegister,
    props: (route) => ({
      manifestoId: parseInt(route.query.manifestoId, 10) || null,
    }),
    meta: {
      title: 'Nova Compra',
    },
  },
  {
    path: '/inventory/purchase/edit/:id',
    name: 'PurchaseEdit',
    component: PurchaseEdit,
    meta: {
      title: 'Editar Compra',
    },
  },
];
